import { useApolloClient } from '@apollo/client';
import useUserData from 'components/hooks/useUserData';
import { useFirebase } from 'contexts/FirebaseContext';
import { secureCachePersistor } from 'graphql/secure/SecureApolloProvider';
import { useEffect } from 'react';

/**
 * Automatically logout user when user is still found
 * This should be used on un-authenticated pages to make sure the data is cleared
 */
const useAutoLogout = () => {
  const { user } = useUserData();
  const { logout } = useFirebase();
  // https://github.com/apollographql/apollo-client/issues/4970
  // The functions lose their this context when you destructure them from the instantiated Apollo Client because they are currently written as class methods
  const client = useApolloClient();

  const handleLogout = async () => {
    await client.clearStore();
    await secureCachePersistor.purge();
    logout();
  };

  useEffect(() => {
    if (!!user) {
      handleLogout();
    }
    // No dependencies because checking only on render will be enough, otherwise it will trigger on login
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useAutoLogout;
